import React from 'react';
import useSortableTable from './useSortableTable';
import './SortableTable.css';
import { calculateMarketValue, formatCurrency, getRowKey } from './helpers';

function CashTable({ cash_positions, onDelete, onEdit, onUpdate, editQuantity, setEditQuantity, editingPosition }) {
  const columns = ['position', 'quantity', 'price', 'marketValue'];
  const { sortedData, requestSort, getSortClass } = useSortableTable(cash_positions, columns);

  return (
    <div>
      <h2>Cash</h2>
      <div className="table-responsive-wrapper">
      <table>
        <thead>
          <tr>
            <th>Ticker</th>
            <th onClick={() => requestSort('quantity')} className={getSortClass('quantity')}>Quantity</th>
            <th>Price</th>
            <th onClick={() => requestSort('marketValue')} className={getSortClass('marketValue')}>Market Value</th>
            <th>Actions</th>
	  </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => (
            <tr key={index}>
              <td>{item.position}</td>
              <td>{item.quantity}</td>
              <td>{formatCurrency(1)}</td>
              <td>{formatCurrency(calculateMarketValue(item.quantity, '1'))}</td>
	      <td>
                <button onClick={() => onDelete(item)}>Delete</button>
                {editingPosition === getRowKey(item) ? (
                  <div>
                    <input
                      type="number"
                      value={editQuantity}
                      onChange={(e) => setEditQuantity(e.target.value)}
                    />
                    <button onClick={() => onUpdate(item)}>Save</button>
                    <button onClick={() => onEdit(null)}>Cancel</button>
                  </div>
                ) : (
			 <button onClick={() => {
    onEdit(getRowKey(item));
    setEditQuantity(item.quantity);
  }}>Edit</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
}

export default CashTable;
